import type { Holiday } from './@types/HolidayModel';
export class HolidayRepository {
    private httpService: IHttpService;
    constructor(instance: IHttpService) {
        this.httpService = instance;
    }
    async getHolidays(): Promise<Holiday[]> {
        try {
            const response = await this.httpService.get<TKResponse<Holiday[]>>('/holidays');
            return response.data
                .map((holiday) => ({ ...holiday, id: holiday.holiday_id }))
                .sort((a, b) => ((a as any).name ?? '').localeCompare((b as any).name ?? ''));
        } catch (error) {
            console.error('Error al obtener las vacaciones:', error);
            throw error;
        }
    }

    async createHoliday(holiday: Holiday): Promise<Holiday> {
        try {
            const response = await this.httpService.post<Holiday, Holiday>('/holidays', { data: holiday });
            return response;
        } catch (error) {
            console.error('Error al crear el feriado:', error);
            throw error;
        }
    }

    async deleteHoliday(id: number): Promise<number> {
        try {
            const response = await this.httpService.delete<number>(`/holidays/${id}`);
            return response;
        } catch (error) {
            console.error('Error al eliminar el feriado:', error);
            throw error;
        }
    }

    async updateHoliday(holiday: Holiday): Promise<Holiday> {
        try {
            const response = await this.httpService.patch<Holiday, Holiday>(`/holidays/${holiday.holiday_id}`, { data: holiday });
            return response;
        }
        catch (error) {
            console.error('Error al actualizar el feriado:', error);
            throw error;
        }
    }

}